import script from "./TireApprovalFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./TireApprovalFilters.vue?vue&type=script&setup=true&lang=ts"

import "./TireApprovalFilters.vue?vue&type=style&index=0&id=dacc2376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dacc2376"]])

export default __exports__